const concat = "<br />"

const aboutincred = {
    "About InCred Finance IPO": [
        {
          question: "What is the IPO issue open date and the close date?",
          answer: "The IPO issue will be open for investors on Bidd from 25th Oct ’23 to 7th Nov ’23."
        },
        {
          question: "What are the important details of the IPO offering",
          answer:  `<ul>
          <li><b>Name of the Issuer</b>: Incred Financial Services</li>
          <li><b>Security Name</b>: Series I, Series II, Series III, Series IV, Series V</li>
          <li><b>ISIN</b>: Will be issued later</li>
          <li><b>Seniority</b>: Senior</li>
          <li><b>Original Mode of Issue</b>: Public Issue, <b>Date of Issue</b>: N/A</li>
          <li><b>Rating of the instrument</b>: CRISIL A+/Stable, Date of rating: 14th Sep, 2023, <b>Rating Agency</b>: CRISIL</li>
          <li><b>Face Value</b>: 1,000Rs</li>
          <li><b>Clean Price and Dirty Price</b>: N/A</li>
          <li><b>Coupon</b>: Fixed</li>
          <li><b>Coupon Rate</b>: Refer Issue Structure</li>
          <li><b>Coupon Frequency</b>: Refer Issue Structure</li>
          <li><b>Tenor</b>: Refer Issue Structure</li>
          <li><b>Name of Debenture trustee</b>: Catalyst Trusteeship Limited</li>
          <li><b>Yield</b>: Current yield and yield to maturity - Refer Issue Structure</li>
          <li><b>Calculation of such yields</b>: N/A</li>
           <ul>`
        },
        {
          question: "What is the coupon, yield and tenure of the bond available for investing?",
          answer: "There are 5 series available for investing with different features. You may invest in either one or more of the following series."
        },
        {
          question: "How do I apply for the IPO?",
          answer: "There are two ways to apply for the IPO:" + concat +
  
          "Online: For overall application of less than Rs. 10 Lakhs " + concat +
          "Offline: For overall application above Rs. 10 Lakhs" + concat +
          
          "*For the Limit of Rs. 10 Lakhs, all application amounts across different series will be considered."
        },
        {
          question: "What is the Minimum Amount that can be invested in the Issue?",
          answer: "Through the Bidd platform, the minimum ticket size for investing is ₹10,000 in a single series."      
        },
        {
          question: "How will I get allotment and when will the allotment happen?",
          answer: "The allotment will happen on a First Come First service basis."  + concat +
          "For eg. If the IPO gets full subscribed by day 3, then applications from the 4th day onwards may not get any allocation."
        },
        {
          question: "How do I make the payment?",
          answer: "There will be no payment to be done at the time of either Online or Offline application. The payment will be through ASBA Mode. This means that the funds will be blocked by your bank and only when you get a confirmed allocation, the funds will be debited from your account. If there is no allocation, then the funds will not get debited from your account."
        },
      ],
  }
  
  export default aboutincred;